export enum FolderBusinessEntityActorsActionKind {
  ClearState = 'clearState',
  StartCreate = 'startCreate',
  StartFlush = 'startFlush',
  StartCustomize = 'startCustomize',
  StartRemove = 'startRemove',
  StartUpdate = 'startUpdate',
  EndCreate = 'endCreate',
  EndFlush = 'endFlush',
  EndCustomize = 'endCustomize',
  EndRemove = 'endRemove',
  EndUpdate = 'endUpdate',
}
